import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CmsModules } from 'containers/CmsPage/CmsModules';
import cx from 'classnames';
import css from './Collection.scss';

export class Collection extends Component {
  constructor(props) {
    super(props);
    this.renderItem = this.renderItem.bind(this);
  }

  renderItem(item, idx) {
    return (
      <li key={`item-${idx}`} className={css.Collection__item}>
        <CmsModules modules={[item]} />
      </li>
    );
  }

  render() {
    const { modules, maxColumns, extraClass } = this.props;
    return (
      <div className={cx(css.Collection, css[`Collection--col${maxColumns}`], extraClass)}>
        <ul>{modules.map(this.renderItem)}</ul>
      </div>
    );
  }
}

Collection.propTypes = {
  extraClass: PropTypes.string,
  modules: PropTypes.array,
  maxColumns: PropTypes.oneOf([1, 2, 3, 4]).isRequired,
};
